import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--forest-green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  // ---------------------------------------------------------------------------
  // Suggested research-forward rewording for a graduate-school audience (leads
  // with research intent rather than the SWE role). Swap in / edit freely:
  //
  //   const three = (
  //     <h3 className="big-heading">
  //       I build systems for the mind and the machine.
  //     </h3>
  //   );
  //   const four = (
  //     <>
  //       <p>
  //         Senior Software Engineer at Goldman Sachs · Brain–Computing
  //         researcher (NTU)
  //       </p>
  //       <p>
  //         I work at the intersection of machine learning, affective computing,
  //         and mental health — from EEG-based emotion decoding to production AI
  //         systems.
  //       </p>
  //     </>
  //   );
  // ---------------------------------------------------------------------------
  const one = <h1>Hi, my name is</h1>;
  const two = <h2 className="big-heading">Srishti Arora,</h2>;
  const three = (
    <h3 className="big-heading">I'm building for mental health.</h3>
  );
  const four = (
    <>
      <p>Software Engineer at Goldman Sachs</p>
      <p>
        I am exploring my interests in software engineering and brain computing
        research with the aim of making a meaningful impact.
        <br />
      </p>
      <p>Step into my world, and let me share more about myself.</p>
    </>
  );

  const items = [one, two, three, four];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
